const jaJP = {
  '青瓷游戏官方充值中心': 'ศูนย์เติมเงินทางการของ QCPLAY',
  '官方充值': 'เติมเงินผ่านช่องทางการ',
  '我的订单': 'บันทึกการชำระเงิน',
  '联系客服': 'ติดต่อฝ่ายบริการลูกค้า',
  '您好，请登录': 'โปรดล็อกอินเป็นก่อน',
  '注销': 'ลบบัญชี',
  '最强蜗牛': 'Super Snail',
  '角色名称.游戏区组': 'ชื่อเล่นเกม เซิร์ฟเวอร์เกม',
  '代钞': 'เช็คเงินสด',
  '所选商品': 'สินค้าที่เลือก',
  '含': 'ได้รับ',
  '赠': 'แถมฟรี',
  '等待支付结果完成中': 'กำลังรอผลตอบกลับการชำระเงินเสร็จสิ้นอยู่',
  '请稍后': 'โปรดรอสักครู่',
  '代钞具体到账情况请到': 'โปรดเข้าเช็คกระเป๋าเกม',
  '游戏“背包”中进行查看': 'เพื่อตรวจสอบว่าเช็คเงินสดที่เติมได้เข้าบัญชีเรียบร้อยหรือยัง',
  '支付查询中': 'ตรวจสอบสถานะการชำระเงินอยู่',
  '合计': 'รวมเป็น',
  '充值说明': 'รายละเอียดการเติมเงิน',
  '立即支付': 'ชำระเงินทันที',
  '青瓷游戏': 'QCPLAY',
  '官方充值中心': 'ศูนย์เติมเงินทางการ',
  '角色名称': 'ชื่อตัวละคร',
  '游戏区组': 'เซิร์ฟเวอร์เกม',
  '充值账号': 'ข้อตกลงการใช้งาน',
  '选择游戏区组': 'เลือกเซิร์ฟเวอร์เกม',
  '苹果': 'IOS',
  '安卓': 'ANDROID',
  '请选择区组': 'กรุณาเลือกเซิร์ฟเวอร์เกม',
  '请选择角色': 'กรุณาเลือกตัวละคร',
  '取消': 'ยกเลิก',
  '确定': 'ยืนยัน',
  '温馨提示': 'คำเตือน',
  '游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解': 'ในช่วงการบำรุงรักษาเกม จะไม่สามารถเติมเงินได้เป็นชั่วคราว ขออภัยในความไม่สะดวกที่เกิดขึ้น',
  '好的': 'ตกลง',
  '请选择商品类目': 'กรุณาเลือกประเภทสินค้า',
  '请选择区组信息': 'กรุณาเลือกข้อมูลเซิร์ฟเวอร์เกม',
  '登录': 'เข้าสู่ระบบ',
  '请先同意下方《青瓷游戏隐私政策》、《青瓷游戏用户服务协议》': 'โปรดยอมรับ "นโยบายความเป็นส่วนตัว " และ "ข้อตกลงการใช้งาน" ต่อไปนี้เป็นก่อน',
  '邮箱信息填写错误': 'ข้อมูลอีเมลไม่ถูกต้อง',
  '登录成功': 'เข้าสู่ระบบสำเร็จ',
  '共': 'รวมเป็น',
  '条': 'รายการ',
  '选择需要充值的游戏': 'เลือกเกมที่ต้องการเติมเงิน',
  '您好，': 'สวัสดี',
  '暂无信息': 'ไม่มีข้อมูล',
  '请登录': 'กรุณาเข้าสู่ระบบ',
  '购买的代劵将反映在以下账号内，请确认内容无误': 'เช็คเงินสดที่ซื้อจะถูกส่งไปยังบัญชีต่อไปนี้ โปรดยืนยันว่าเนื้อหาถูกต้อง',
  '支付成功': 'ชำระเงินสำเร็จ',
  '代钞具体到账情况请到游戏“背包”中进行查看': 'โปรดเข้าเช็คกระเป๋าเกม เพื่อตรวจสอบว่าเช็คเงินสดที่เติมได้เข้าบัญชีเรียบร้อยหรือยัง',
  '支付失败': 'การชำระเงินล้มเหลว',
  '请稍后再试': 'กรุณาลองใหม่อีกครั้งในภายหลัง',
  '查看订单': 'ตรวจสอบการสั่งซื้อ',
  '网络超时,请刷新页面或稍后重试': 'เชื่อมต่อเครือข่ายหมดเวลา โปรดรีเฟรชหน้านี้หรือลองอีกครั้งในภายหลัง',
  '订单号': 'หมายเลขคำสั่งซื้อ',
  '下单时间': 'เวลาสั่งซื้อ',
  '开始日期': 'วันที่เริ่มต้น',
  '至': 'ถึง',
  '结束日期': 'วันที่สิ้นสุด',
  '没有更多了': 'ไม่มีอีกแล้ว',
  '全部游戏': 'เกมส์ทั้งหมด',
  '恭喜您复制成功，赶快去粘贴吧': 'ยินดีด้วยที่คัดลอกสำเร็จ รีบไปวางเลย~',
  '操作失败，请重试！': 'การดำเนินการล้มเหลว โปรดลองอีกครั้ง!',
  '遇到问题？': 'พบเจอปัญหาเหรอ?',
  '邮箱账号登录': 'ล็อกอินด้วยบัญชีอีเมล',
  '请输入邮箱': 'โปรดกรอกอีเมล',
  '请输入密码': 'โปรดกรอกรหัส',
  '查看如何拥有邮箱账号': 'เช็คดูวิธีการสร้างบัญชีอีเมล',
  '年龄认证': '年齢確認',
  '您的年龄决定了您每月可以购买的可计费项目的数量。': 'あなたの年齢によって1ケ月に購入できる有償アイテムの上限額が決まっています。',
  '请输入正确的出生日期。': '正しい生年月日を入力してください。',
  '设定的出生日期以后不能更改。': '設定した生年月日は後から変更できません',
  '16岁以下': '16歳未満',
  '16岁以上18岁未满': '16歳以上18歳未満',
  '18岁及以上': '18歳以上',
  '1个月': '1ヶ月',
  '无限制': '制限なし',
  '5000元以下': '5000円まで',
  '20000元以下': '20000円まで',
  '年': '年',
  '月': '月',
  '日': '日',
  '元': '฿',
  '阅读并同意': 'อ่านและยมรับ',
  '《青瓷游戏隐私政策 》': '"นโยบายความเป็นส่วนตัว"',
  '《青瓷游戏用户服务协议》': '"ข้อตกลงการใช้งาน"',
  '在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试': 'เมื่อทำการชำระเงิน เนื่องจากกฎที่เกี่ยวข้องของช่องทางการชำระเงิน อาจมีการแจ้งเตือนที่เกินราคา การแจ้งเตือนที่เกินกำหนด การแจ้งเตือนความเสี่ยง ฯลฯ คุณสามารถเปลี่ยนวิธีการชำระเงินและลองอีกครั้ง',
  '温馨提示：请您知悉，点击立即支付即视为您同意': 'คำเตือน: โปรดทราบว่าการคลิกชำระเงินจะถือว่าคุณยมรับกับ'
}

export default jaJP